module.exports = __webpack_public_path__ + "static/media/blocks.9e9a3aa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/thumbnails/blocks.png
// module id = 237
// module chunks = 0